<template>
    <div class="checkout-page">
        <div class="d-flex flex-column min-vh-100">
            <div class="flex-grow-1 d-flex flex-column wrapper">
                <div :class="{'border-wrapper mb-4': isProofreading}">
                    <div :class="['container', {'plagiarism-wrapper mt-sm-5': !isProofreading}]">
                        <div class="d-flex align-items-center justify-content-between ml-n2">
                            <div class="d-flex align-items-center header">
                                <a :href="$t('order.ai_proofreader.upload_document.logo.link')" class="d-flex text-decoration-none p-2">
                                    <img class="logo" src="~/assets/img/logo.svg" alt="">
                                </a>
                                <h1 class="logo-text mb-0" v-text="$t(`checkout_header.logo.${service}`)" />
                            </div>
                            <div>
                                <BaseButton
                                    v-if="isProofreading"
                                    variant="link"
                                    class="btn ml-auto help"
                                    v-text="$t('checkout_header.btn.help')"
                                />
                                <a v-if="isImpersonated() && user" class="btn impersonate-btn ml-2" :href="user.links.exit_impersonate">
                                    <FontAwesomeIcon icon="user-secret" />
                                    <FontAwesomeIcon icon="sign-out-alt" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <ul v-if="isProofreading" class="nav steps-nav justify-content-center bg-white d-none d-md-flex">
                        <li v-for="(step, stepKey) in navigatorSteps" :key="stepKey" class="nav-item">
                            <a :class="`nav-link font-weight-bold ${step.completed ? 'completed' : 'active disabled'}`"
                               :href="step.completed && Route(step.name)"
                               v-text="$t(`checkout_header.navigator.step.${step.name}`)"
                            />
                            <span v-if="step.completed" class="completed-icon"><FontAwesomeIcon icon="check" /></span>
                        </li>
                    </ul>
                </div>
                <div v-if="!isProduction" class="alert alert-warning text-center rounded-0 border-0 mb-3">
                    You are now working on the <span v-text="env" /> environment
                </div>
                <nuxt />
            </div>
            <Footer :footer-links="footerLinks" :gray-theme="true" />
        </div>
        <PortalTarget name="modal" />
    </div>
</template>

<script>
import Base from '@/layouts/base';
import Footer from 'frontend-resources/components/Footer/Footer';
import BaseButton from '~/components/BaseButton';
import { faCheck, faUserSecret, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import Route from '~/extensions/Route/Route';

library.add(faCheck, faUserSecret, faSignOutAlt,);

export default {
    components: { BaseButton, Footer, FontAwesomeIcon },
    extends: Base,
    head() {
        return {
            title: this.$t('checkout.head.title'),
        };
    },
    data() {
        return {
            navigatorSteps: [
                { name: 'upload_document', completed: true },
                { name: 'your_info', completed: true },
                { name: 'pages_services', completed: true },
                { name: 'important_info', completed: true },
                { name: 'payment' },
            ],
            Route,
        };
    },
    computed: {
        isProduction() {
            return process.env.isProduction;
        },
        env() {
            return process.env.NODE_ENV;
        },
        service() {
            return this.$route.query.service;
        },
        isProofreading() {
            return this.$route.query.service === 'proofreading';
        },
        isPlagiarism() {
            return this.$route.query.service === 'plagiarism';
        },
    },
    mounted() {
    },
    methods: {
        isImpersonated() {
            return this.user && this.user.links.exit_impersonate;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~assets/css/_base.scss';

.wrapper {
  background-color: #f8f9fa;
}
.border-wrapper {
  border-bottom: 1px solid #bfc6da;
}
.plagiarism-wrapper {
  margin-top: 1rem;
  margin-bottom: 2.5rem;
}
.header {
  padding: .25rem 0;
}
.logo-text {
  font-size: 1.875rem;
  line-height: 2.25rem;
  @media (max-width: 576px) {
    white-space: pre-wrap;
    word-spacing: 100vw;
  }
}
.logo {
  width: 45px;
  height: auto;
}
.experiment-logo {
  width: 45px;
  height: auto;
}
.help {
  background-color: #e8f2fc;
  text-decoration: none;
}
.alert-warning {
  position: relative;
  margin-bottom: 0;
  padding-bottom: .25rem;
  padding-top: .25rem;
  border: 1px solid #fc5b24;
  color: #d44c1e;
  background-color: #feded3;
  font-weight: bold;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin-bottom: 0;
  padding-left: 0;
  border-top: 1px solid #bfc6da;
}

.nav-item {
  position: relative;
}

.nav-link {
  border-bottom: 2px solid #fff;
  margin-left: .75rem;
  margin-right: .75rem;
  padding: 1.5rem 0;
  display: block;
  text-decoration: none;
  &:hover {
    color: #14ac9d;
  }
}

.completed {
  color: #108b7f;
  cursor: pointer
}

.active {
  color: #108b7f;
  border-color: #108b7f;;
}

.disabled {
  cursor: default;
  pointer-events: none;
}

.completed-icon {
  background: #108b7f;
  border-radius: 50%;
  bottom: -.75rem;
  color: #fff;
  height: 1.5rem;
  left: 50%;
  line-height: 1.5rem;
  margin-left: -.75rem;
  position: absolute;
  text-align: center;
  width: 1.5rem;
}

.impersonate-btn {
  background-color: #fc5b24;
  border-color: #fc5b24;
  color: #fff;
  border-radius: .25rem;
  &:hover {
    background-color: #f64103;
    border-color: #ea3e03;
    text-decoration: none;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(252, 116, 69, 0.5);
  }
}

</style>
